<div class="barra-flex-space-between">
  <h1>Gestión empleados</h1>
  <div class="acciones">
    <app-empleados-barra-superior (botonClicked)="clickBarraSuperior($event)"></app-empleados-barra-superior>
    <app-boton-accion [id]="'importar'" [icono]="'hs-upload'" [titulo]="'importar'" [outline]="true"  [cancelar]="true" (click)="goToImportEmpleados()"></app-boton-accion>
    <app-boton-accion [id]="'nuevo empleado'" [icono]="'icon-plus'" [titulo]="'nuevo empleado'" [outline]="false" (click)="creaNuevoEmpleado()"></app-boton-accion>
  </div>
</div>
<div class="main">
  <div [style.display]="empleadosSeleccionados.length==0 ? 'flex' : 'none'" class="flex-center-items">
    <app-input-buscador (buscador)="buscarEmpleados($event)" [textoBuscar]="textoBuscar"></app-input-buscador>
    <app-empleados-filtros (filtrosNuevosEmitter)="filtrarEmpleados($event)"
                           [textoBuscar]="textoBuscar"
                           [empresasList]="empresasLista"
                           [centrosList]="centrosLista"
                           (limpiarBuscador)="buscarEmpleados($event)"
                          ></app-empleados-filtros>
                          <!-- (limpiarTodoEmitter)="limpiarTodosEstados($event)" -->
  </div>
  <app-pastilla-seleccion-multiple *ngIf="empleadosSeleccionados.length>0"
                                   (borrarEmitter)="deleteEmpleado()"
                                   (deseleccionarEmitter)="deseleccionarAll()"
                                   [textoMostrar]="textoBorrar"
                                   [tipoDato]="'empleados'"></app-pastilla-seleccion-multiple>
  <app-sqp-grid-component #sqpGrid
                          [data]="empleados"
                          [columnDefs]="columnDefs"
                          [seleccion]="'multiple'"
                          [suppressSelectionEvents]="gridSuppressSelectionEvents"
                          (seleccionEliminarEmitter)="seleccionEmpleados($event)"
                          (headerSelectionToggled)="onHeaderSelectionToggled($event)"
                          (abrirModalDataEmitter)="abreModal($event)"
                          [iconoEditar]="true"
                          (ordenColumnaEmitter)="ordenarGrid($event)"
                          (onScrollEnd)="loadRows()"
                          [gridOptions]="gridOptions">
  </app-sqp-grid-component>
</div>

